import { render } from "./zxfu.vue?vue&type=template&id=881d86da"
import script from "./zxfu.vue?vue&type=script&lang=js"
export * from "./zxfu.vue?vue&type=script&lang=js"

import "./zxfu.vue?vue&type=style&index=0&id=881d86da&lang=less"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.21_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__